import { render, staticRenderFns } from "./AssociationAdmins.vue?vue&type=template&id=7f7af0b1&scoped=true"
import script from "./AssociationAdmins.vue?vue&type=script&lang=js"
export * from "./AssociationAdmins.vue?vue&type=script&lang=js"
import style0 from "./AssociationAdmins.vue?vue&type=style&index=0&id=7f7af0b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7af0b1",
  null
  
)

export default component.exports